import React from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { TouchBackend } from "react-dnd-touch-backend";
import CommonThreeBoard from "./CommonThreeBoard";

const CommonThree = () => {
  // Check if touch device
  const isTouchDevice = () => {
    return "ontouchstart" in window || navigator.maxTouchPoints > 0;
  };

  return (
    <DndProvider
      backend={isTouchDevice() ? TouchBackend : HTML5Backend}
      options={
        isTouchDevice()
          ? {
              enableMouseEvents: true,
              enableHoverOutsideTarget: true,
            }
          : {}
      }
    >
      <CommonThreeBoard />
    </DndProvider>
  );
};

export default CommonThree;
